(() => {
  function ga4Event(name, link) {
    const params = {
      event_category: 'local_intent',
      link_url: link.getAttribute('href') || '',
      link_text: (link.textContent || '').trim().slice(0, 100),
      page_location: window.location.href,
      transport_type: 'beacon',
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    if (/^tel:/i.test(href)) {
      ga4Event('click_to_call', link);
      return;
    }

    if (/^https?:\/\/(?:www\.)?(?:maps\.app\.goo\.gl|google\.[^/]+\/maps|maps\.google\.[^/]+)/i.test(href)) {
      ga4Event('directions_click', link);
    }
  }, { passive: true });
})();
